import { render, staticRenderFns } from "./NewsArticleSummary.vue?vue&type=template&id=0b3eb2da&"
import script from "./NewsArticleSummary.vue?vue&type=script&lang=js&"
export * from "./NewsArticleSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports